export default __webpack_public_path__ + "static/speaker-detail-1-3fc05b85cfab851a79dcb5f29c36f5dd.png";